module.exports = __webpack_public_path__ + "img/chat_2.af8090b5.png";